<template>
  <div class="visitor-layout">
    <div class="px-0 mx-0" id="nav">
      <Header />

      <main class="layout-main">

        <div class="layout-router-view">
          <VersionBanner />
          <div class="alert-message-wrapper" :style="{'background-color': alertBackgroundColor}" v-if="alertMessage && !alertMessageClosedLocal">
            <div class="row alert-message">
              <div class="alert-message col-11" @click="alertMessageClicked">{{ alertMessage.Message }}</div>
              <div class="alert-message-close col-1">
                <i @click="closeAlertMessage" class="fa fa-times-circle pointer" aria-hidden="true"></i>
              </div>
            </div>
          </div>
          <router-view/>
        </div>

        <Modal ref="alertDialog" width="800" transition="fade-transition">
          <div class="message-dialog">
            <MarkdownMessageDialog
              v-bind:title="title"
              v-bind:message="message"
              v-bind:color="color"
              v-on:close-dialog="closeDialog"
            ></MarkdownMessageDialog>
          </div>
        </Modal>
      </main>

    </div>
  </div>
</template>
<script>
import Header from '../../components/Header.vue';
import MarkdownMessageDialog from '../../components/MarkdownMessageDialog.vue';
import VersionBanner from '../../components/VersionBanner.vue';
import { mapState } from 'vuex';

export default {
  components:{
    Header,
    MarkdownMessageDialog,
    VersionBanner,
  },
  data(){
    return{
      alertMessageClosedLocal: false,
      alertMessageOneTimeLocal: false,
      bannerPollInterval: null,
    }
  },
  computed: {
    ...mapState(['alertMessage', 'alertMessageClosed', 'alertBackgroundColor']),
    title() {
      return this.alertMessage?.MessageTitle;
    },
    message() {
      return this.alertMessage?.MessageBody;
    },
    color() {
      return this.alertMessage?.BackgroundColor;
    }
  },
  methods: {
    closeAlertMessage(){
      if (this.alertMessageOneTimeLocal) {
        localStorage.setItem('alertMessageClosed', 'true');
      }

      this.$store.dispatch('SET_ALERT_MESSAGE_CLOSED', true);
      this.alertMessageClosedLocal = true;
    },
    alertMessageClicked() {
      this.$refs.alertDialog.openModal();
    },
    closeDialog() {
      this.$refs.alertDialog.closeModal();
    }
  },
  created() {
    // Handle null/undefined localStorage values properly
    const alertClosed = localStorage.getItem('alertMessageClosed');
    this.alertMessageClosedLocal = alertClosed ? JSON.parse(alertClosed) : false;
    this.alertMessageOneTimeLocal = localStorage.getItem('alertMessageIsOneTime') === 'true';

    // Load alert message when on login page - use the store action for consistent logic
    this.$store.dispatch('GET_ALERT_MESSAGE');
    this.$store.dispatch('GET_APP_VERSION');
  },
  mounted() {
    // Poll for banner and notification updates every 60 seconds
    this.bannerPollInterval = setInterval(() => {
      this.$store.dispatch('GET_ALERT_MESSAGE');
      this.$store.dispatch('GET_USER_NOTIFICATIONS');
      this.$store.dispatch('GET_APP_VERSION');
    }, 60000);
  },
  beforeDestroy() {
    // Clean up the polling interval
    if (this.bannerPollInterval) {
      clearInterval(this.bannerPollInterval);
    }
  }
};
</script>

<style lang="scss" scoped>
  .visitor-layout {
    height: 100%;
    background: $white;

    .layout-main {
      height: calc(100vh - 50px);
      display: flex;
    }
    .layout-router-view {
      width: 100%;
      overflow: scroll;
      padding: 15px 30px;

      .alert-message-wrapper{
        min-height: 25px;
        width: 100%;
        color: black;
        display: flex;
        justify-content: space-between;
        align-items: center;
        overflow-wrap: anywhere;
        padding: 10px;
        margin-bottom: 15px;
        .alert-message{
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
        .alert-message-close{
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
    }

    .message-dialog {
      width: 600px;
      display: flex;
      font-size: 1.2em;
      justify-content: space-around;
      align-items: center;
      .modal-text{
        text-align: center;
        margin-top: 10px;
        margin-bottom: 0px;
      }
      .btn-wrapper{
        margin-top: 25px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        .btn{
          min-height: 100%;
          min-width: 125px;
        }
        &.center{
          justify-content: space-around;
          align-items: center;
        }
      }
    }
  }
</style>
